module.exports = __webpack_public_path__ + "static/potted-small-207c7f8d99bd14fb23c0e319c6b1a7dd.png";